var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"stage"},[_vm._v("\n  Carregando "),_c('div',{staticClass:"dot-elastic"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }